import {
    Box,
    Button,
    Card,
    Container,
    FormControl,
    FormControlLabel,
    Grid,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    Stack,
    Table,
    TableBody,
    TableContainer,
    Typography,
} from '@mui/material';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import AddButton from 'src/components/Button.js/AddBotton';
import ButtonAction from 'src/components/Button.js/SaveButton';
import EmtyData from 'src/components/emty-data';
import Iconify from 'src/components/iconify';
import ComboBox from 'src/components/Input/ComboBox';
import DatePickerValue from 'src/components/Input/DatePickerValue';
import TextInput from 'src/components/Input/TextInput';
import Loader from 'src/components/loader/loader';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import Item from './item';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import RejectRequest from './modal/rejectRequest';
import ImageQRCodeModal from 'src/components/modal/ImageQRCodeModal';
import Item2 from './item2';
import ApproveChangeDevice from './modal/approveChangeDevice';
import AdminTakeDevice from './modal/adminTakeDevice';
import AdminPutDevice from './modal/adminPutDevice';

const STATUS_COLOR = {
    0: 'secondary',
    1: 'primary',
    2: 'info',
    3: 'warning',
    4: 'error',
};

const STATUS_COLOR2 = {
    0: 'secondary',
    1: 'info',
    2: 'error',
    3: 'warning',
    4: 'primary',
};

const ApproveRequest = () => {
    const success = useRef(false);
    const { t } = useTranslation();
    const getRef = useRef(false);
    const changeStatusRef = useRef(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [openRowIndex, setOpenRowIndex] = useState(null);
    const [visibleImageQR, setVisibleImageQR] = useState(false);

    const [visibleOpenChecking, setVisibleOpenChecking] = useState(false);
    const [visibleOpenAdminTakeDevice, setVisibleOpenAdminTakeDevice] = useState(false);
    const [visibleOpenAdminPutDevice, setVisibleOpenAdminPutDevice] = useState(false);

    const [viewType, setViewType] = useState(1);
    const [visibleApprove, setVisibleApprove] = useState(false);
    const [visibleReject, setVisibleReject] = useState(false);
    const lastIdRef = useRef(0);
    const dataRef = useRef(null);
    const [totalData, setTotalData] = useState(0);
    const valueSearch = useRef({
        key: '',
        startDay: moment().subtract(1, 'months').format('YYYYMMDD'),
        endDay: moment().format('YYYYMMDD'),
        status: '0',
    });

    const ARR_STATUS = [
        { label: t('all'), value: 'all' },
        { label: t('waiting_confirm'), value: '0' },
        { label: t('approved'), value: '1' },
        { label: t('is_processing'), value: '2' },
        { label: t('taken'), value: '3' },
        { label: t('cancel'), value: '4' },
    ];

    const ARR_STATUS2 = [
        { label: t('all'), value: 'all' },
        { label: t('waiting_confirm'), value: '0' },
        { label: t('confirm'), value: '1' },
        { label: t('reject'), value: '2' },
        { label: t('user_take'), value: '3' },
        { label: t('admin_checking'), value: 'admin_check' },
        { label: t('done'), value: '4' },
    ];
    const handleOnChange = (e, key) => {
        valueSearch.current[key] = e;
    };

    useEffect(() => {
        setTimeout(() => {
            valueSearch.current.status = viewType == 1 ? '0' : 'all';
            getData();
        }, 1000);
    }, [success.current, viewType]);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [
            9999999999999,
            valueSearch.current.key,
            valueSearch.current.status,
            valueSearch.current.startDay,
            valueSearch.current.endDay,
        ];
        sendRequest(
            viewType == 1 ? serviceList.getListRequestDevice : serviceList.getListRequestChangeDevice,
            InVal,
            getDataResult,
            true,
            timeOutFunct,
            15000
        );
    }, [success.current, valueSearch, viewType]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
            setTotalData(message.proc_data.rowTotal || 0);
            lastIdRef.current =
                message.proc_data.rows[0].o_1[message.proc_data.rows[0].o_1.length - 1]?.id || 9999999999999;
        }
    };

    const changeStatus = useCallback(
        (id, status, note_reject) => {
            if (changeStatusRef.current) {
                return;
            }
            changeStatusRef.current = true;
            setGetFlags(true);
            const InVal = [id, viewType === 1 ? status : '2'];
            if (note_reject) {
                InVal.push(note_reject);
            }
            sendRequest(
                viewType === 1 ? serviceList.changeStatusRequestDevice : serviceList.changeStatusChangeDevice,
                InVal,
                changeStatusResult,
                true,
                timeOutFunct,
                15000
            );
        },
        [success.current, valueSearch, viewType]
    );

    const changeStatusResult = (reqInfoMap, message) => {
        changeStatusRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        changeStatusRef.current = false;
        toast.error(t('error.time_out'));
    };

    const getDataNext = (lastId = lastIdRef.current) => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [
            lastId,
            valueSearch.current.key,
            viewType == 1 ? '0' : valueSearch.current.status,
            valueSearch.current.startDay,
            valueSearch.current.endDay,
        ];

        sendRequest(
            viewType == 1 ? serviceList.getListRequestDevice : serviceList.getListRequestChangeDevice,
            InVal,
            getDataNextResult,
            true,
            timeOutFunct,
            15000
        );
    };

    // region getDataNextResult
    const getDataNextResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataRes = message.proc_data.rows[0]?.o_1 || [];
            if (dataRes?.length) lastIdRef.current = dataRes[dataRes.length - 1].id;
            setTableData([...tableData, ...dataRes]);
            setTotalData(message.proc_data.rowTotal || 0);
            console.log('dataRes', dataRes);
        }
    };

    // region TABLE_HEAD
    const TABLE_HEAD = [
        { id: '', label: '', alignRight: false },
        { id: '', label: '#', alignRight: false },
        { id: 'QR', label: 'QR', alignRight: false },
        { id: 'status', label: t('status'), alignRight: false },
        { id: 'code', label: t('code'), alignRight: false },
        { id: 'dateRequest', label: t('dateRequest'), alignRight: false },
        { id: 'userRequest', label: t('userRequest'), alignRight: false },
        { id: 'userApproveOrReject', label: t('userApproveOrReject'), alignRight: false },
        { id: 'dateApproveReject', label: t('dateApproveReject'), alignRight: false },
        { id: 'price', label: t('price'), alignRight: false },
        { id: 'note_', label: t('note_'), alignRight: false },
        { id: 'note_reject', label: t('note_reject'), alignRight: false },

        { id: 'action', label: '', alignRight: false, stickyEnd: true },
    ];

    const TABLE_HEAD2 = [
        { id: '', label: '', alignRight: false },
        { id: '', label: '#', alignRight: false },
        { id: 'status', label: t('status'), alignRight: false },
        { id: 'name', label: t('device'), alignRight: false },
        { id: 'info', label: t('info'), alignRight: false },
        { id: 'code_device', label: t('code_device'), alignRight: false },
        { id: 'dateRequest', label: t('dateRequest'), alignRight: false },
        { id: 'userRequest', label: t('userRequest'), alignRight: false },
        { id: 'userApproveOrReject', label: t('userApproveOrReject'), alignRight: false },
        { id: 'dateApproveReject', label: t('dateApproveReject'), alignRight: false },
        { id: 'info_take', label: t('info_take'), alignRight: false },
        { id: 'user_take_date', label: t('user_take_date'), alignRight: false },
        { id: 'note_', label: t('note_'), alignRight: false },
        { id: 'note_reject', label: t('note_reject'), alignRight: false },

        { id: 'action', label: '', alignRight: false, stickyEnd: true },
    ];

    return (
        <>
            <Helmet>
                <title> {t('list_request')}</title>
            </Helmet>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('list_request')}
                    </Typography>
                </Stack>
                <Breadcrumb paths={[{ label: t('list_request'), url: '#', navigate: false }]} />
                <Loader loading={getFlags} />
                <ImageQRCodeModal
                    visible={visibleImageQR}
                    setVisible={setVisibleImageQR}
                    valueImageQR={dataRef.current?.code}
                    valueCodeDevice={dataRef?.current?.code}
                    valueNameDevice={dataRef?.current?.code}
                    isRequestDeice={true}
                />
                <Card>
                    <Grid padding={'20px 10px'} container spacing={1} style={{}} alignItems={'center'}>
                        <ConfirmModal
                            visible={visibleApprove}
                            setVisible={setVisibleApprove}
                            title={'approve_request_device'}
                            mesages={'approve_request_device_message'}
                            titleButtonConfirm="confirm"
                            typeButtonConfirm="confirm"
                            callBackFunct={() => {
                                setVisibleApprove(false);
                                getData();
                            }}
                            paramsApi={[dataRef.current?.id || 0, '1']}
                            serviceApi={serviceList.changeStatusRequestDevice}
                        ></ConfirmModal>
                        <RejectRequest
                            changeStatus={changeStatus}
                            visible={visibleReject}
                            setVisible={setVisibleReject}
                            callBackFunct={() => {
                                setVisibleReject(false);
                                getData();
                            }}
                            data={dataRef.current}
                        ></RejectRequest>
                        <ApproveChangeDevice
                            visible={visibleOpenChecking}
                            setVisible={setVisibleOpenChecking}
                            data={dataRef.current}
                            callBackFunct={() => {
                                setVisibleOpenChecking(false);
                                getData();
                            }}
                        />
                        <AdminTakeDevice
                            visible={visibleOpenAdminTakeDevice}
                            setVisible={setVisibleOpenAdminTakeDevice}
                            data={dataRef.current}
                            callBackFunct={() => {
                                setVisibleOpenAdminTakeDevice(false);
                                getData();
                            }}
                        />
                        <AdminPutDevice
                            visible={visibleOpenAdminPutDevice}
                            setVisible={setVisibleOpenAdminPutDevice}
                            data={dataRef.current}
                            callBackFunct={() => {
                                setVisibleOpenAdminPutDevice(false);
                                getData();
                            }}
                        />
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <TextInput
                                size="medium"
                                getValue={(e) => handleOnChange(e, 'key')}
                                label={t('searchDevice')}
                            />
                        </Grid>
                        {viewType === 1 && (
                            <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                                <ComboBox
                                    label={t('filter_status')}
                                    sizeCbb="medium"
                                    displayLabel="label"
                                    valueEqual="value"
                                    getValue={(e) => handleOnChange((e || {})['value'] || 'all', 'status')}
                                    valueSelect={valueSearch.current.status}
                                    selectOption={ARR_STATUS}
                                    required
                                />
                            </Grid>
                        )}
                        {viewType === 2 && (
                            <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                                <ComboBox
                                    label={t('filter_status')}
                                    sizeCbb="medium"
                                    displayLabel="label"
                                    valueEqual="value"
                                    getValue={(e) => handleOnChange((e || {})['value'] || 'all', 'status')}
                                    selectOption={ARR_STATUS2}
                                    valueSelect={valueSearch.current.status}
                                    required
                                />
                            </Grid>
                        )}
                        <Grid item xl={2.5} md={2} sm={12} style={{ width: '100%', minWidth: '230px' }}>
                            <DatePickerValue
                                label={t('start_day')}
                                valueChange={valueSearch.current.startDay}
                                getValue={(e) => handleOnChange(e, 'startDay')}
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2} sm={12} style={{ width: '100%', minWidth: '230px' }}>
                            <DatePickerValue
                                label={t('to_day')}
                                valueChange={valueSearch.current.toDay}
                                getValue={(e) => handleOnChange(e, 'endDay')}
                            />
                        </Grid>
                        <Grid item xl={2} md={2} sm={12} style={{ width: '100%', marginTop: 9 }}>
                            <ButtonAction
                                fullWidth
                                onClick={getData}
                                size="large"
                                type={'search'}
                                title={t('search')}
                                sx={{ padding: 3.3 }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={3}>
                            <FormControl component="fieldset" style={{ width: '100%' }}>
                                <RadioGroup
                                    row
                                    aria-label="view-type"
                                    name="view-type-group"
                                    value={viewType}
                                    onChange={(e) => setViewType(Number(e.target.value))}
                                    style={{
                                        flexWrap: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    <FormControlLabel
                                        value={1}
                                        control={<Radio size="small" />}
                                        label={t('list_rq_device')}
                                        sx={{
                                            '& .MuiFormControlLabel-label': { whiteSpace: 'nowrap' },
                                        }}
                                    />
                                    <FormControlLabel
                                        value={2}
                                        control={<Radio size="small" />}
                                        label={t('list_rq_change_device')}
                                        sx={{
                                            '& .MuiFormControlLabel-label': { whiteSpace: 'nowrap' },
                                        }}
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Stack sx={{ maxHeight: '70vh' }}>
                        <TableContainer>
                            <Table>
                                <DepartmentListHead
                                    order={'asc'}
                                    orderBy={'name'}
                                    headLabel={viewType == 1 ? TABLE_HEAD : TABLE_HEAD2}
                                    rowCount={tableData.length}
                                />
                                <TableBody>
                                    {tableData.length > 0 &&
                                        tableData.map((item, index) => {
                                            return viewType === 1 ? (
                                                <Item
                                                    key={index}
                                                    item={item}
                                                    index={index}
                                                    STATUS_COLOR={STATUS_COLOR}
                                                    dataRef={dataRef}
                                                    setVisibleApprove={setVisibleApprove}
                                                    setVisibleReject={setVisibleReject}
                                                    openRowIndex={openRowIndex}
                                                    setOpenRowIndex={setOpenRowIndex}
                                                    setVisibleImageQR={setVisibleImageQR}
                                                />
                                            ) : (
                                                <Item2
                                                    key={index}
                                                    item={item}
                                                    index={index}
                                                    STATUS_COLOR={STATUS_COLOR2}
                                                    dataRef={dataRef}
                                                    setVisibleApprove={setVisibleApprove}
                                                    setVisibleReject={setVisibleReject}
                                                    openRowIndex={openRowIndex}
                                                    setOpenRowIndex={setOpenRowIndex}
                                                    setVisibleOpenChecking={setVisibleOpenChecking}
                                                    setVisibleOpenAdminTakeDevice={setVisibleOpenAdminTakeDevice}
                                                    setVisibleOpenAdminPutDevice={setVisibleOpenAdminPutDevice}
                                                />
                                            );
                                        })}
                                </TableBody>
                            </Table>
                            {tableData.length === 0 && <EmtyData />}
                        </TableContainer>
                        <Box
                            sx={{ position: 'sticky', zIndex: 1000, bottom: 0, backgroundColor: '#f1f3f4' }}
                            display={'flex'}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            paddingLeft={2}
                            // paddingRight={2}
                        >
                            <Stack>
                                <span>
                                    {t('total_row')}: {tableData.length}/{totalData}
                                </span>
                            </Stack>
                            <Button
                                variant="contained"
                                endIcon={<Iconify icon="material-symbols:skip-next-rounded" />}
                                onClick={() => getDataNext()}
                                disabled={tableData.length < totalData ? false : true}
                            >
                                {t('next')}
                            </Button>
                        </Box>
                    </Stack>
                </Card>
            </Container>
        </>
    );
};
export default ApproveRequest;
